import React, { useState } from 'react';
import { LayoutDashboard, FileText, Users, Settings, Globe, Check, X } from 'lucide-react';
import { CnceLogo } from '../icons/CnceLogo';
interface NavItemProps {
  icon: React.ReactNode;
  label: string;
  active?: boolean;
}
function NavItem({
  icon,
  label,
  active = false
}: NavItemProps) {
  return <button className={`w-full flex items-center gap-3 px-4 py-3 text-left transition-colors ${active ? 'text-white border-l-4' : 'text-gray-300 hover:text-white'}`} style={active ? {
    backgroundColor: '#2d4a63',
    borderLeftColor: '#4a9eff'
  } : undefined} onMouseEnter={e => {
    if (!active) {
      e.currentTarget.style.backgroundColor = '#1e3142';
    }
  }} onMouseLeave={e => {
    if (!active) {
      e.currentTarget.style.backgroundColor = 'transparent';
    }
  }} data-id="element-93">
      {icon}
      <span className="font-medium" data-id="element-94">{label}</span>
    </button>;
}
type Language = 'it' | 'de' | 'en';
interface LanguageOption {
  code: Language;
  name: string;
  flag: string;
}
const languages: LanguageOption[] = [{
  code: 'it',
  name: 'Italiano',
  flag: '🇮🇹'
}, {
  code: 'de',
  name: 'Deutsch',
  flag: '🇩🇪'
}, {
  code: 'en',
  name: 'English',
  flag: '🇬🇧'
}];
interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}
export function Sidebar({
  isOpen,
  onClose
}: SidebarProps) {
  const [selectedLanguage, setSelectedLanguage] = useState<Language>('it');
  const [isLanguageMenuOpen, setIsLanguageMenuOpen] = useState(false);
  const currentLanguage = languages.find(lang => lang.code === selectedLanguage);
  return <aside className={`w-64 text-white flex flex-col h-screen fixed left-0 top-0 z-30 transform transition-transform duration-300 lg:translate-x-0 ${isOpen ? 'translate-x-0' : '-translate-x-full'}`} style={{
    backgroundColor: '#172637'
  }} data-id="element-95">
      {/* Close button for mobile */}
      <button onClick={onClose} className="lg:hidden absolute top-4 right-4 p-2 text-gray-300 hover:text-white" data-id="element-96">
        <X size={24} data-id="element-97" />
      </button>

      {/* Logo/Brand */}
      <div className="p-6 border-b" style={{
      borderColor: '#2d4a63'
    }} data-id="element-98">
        <CnceLogo className="h-12 mb-3" data-id="element-99" />
        <h1 className="text-lg font-semibold" data-id="element-100">Esonero Digitale</h1>
      </div>

      {/* Navigation */}
      <nav className="flex-1 py-4 overflow-y-auto" data-id="element-101">
        <NavItem icon={<LayoutDashboard size={20} data-id="element-103" />} label="Dashboard" data-id="element-102" />
        <NavItem icon={<FileText size={20} data-id="element-105" />} label="Richieste di Esonero" active={true} data-id="element-104" />
        <NavItem icon={<Users size={20} data-id="element-107" />} label="Lavoratori" data-id="element-106" />
        <NavItem icon={<Settings size={20} data-id="element-109" />} label="Impostazioni" data-id="element-108" />
      </nav>

      {/* Language Selector */}
      <div className="p-4 border-t" style={{
      borderColor: '#2d4a63'
    }} data-id="element-110">
        <div className="relative" data-id="element-111">
          <button onClick={() => setIsLanguageMenuOpen(!isLanguageMenuOpen)} className="w-full flex items-center justify-between gap-3 px-4 py-3 text-gray-300 hover:text-white hover:bg-opacity-10 rounded-lg transition-colors" onMouseEnter={e => {
          e.currentTarget.style.backgroundColor = '#1e3142';
        }} onMouseLeave={e => {
          e.currentTarget.style.backgroundColor = 'transparent';
        }} data-id="element-112">
            <div className="flex items-center gap-3" data-id="element-113">
              <Globe size={20} data-id="element-114" />
              <span className="font-medium" data-id="element-115">
                {currentLanguage?.flag} {currentLanguage?.name}
              </span>
            </div>
          </button>

          {/* Language Dropdown */}
          {isLanguageMenuOpen && <div className="absolute bottom-full left-0 right-0 mb-2 rounded-lg shadow-lg overflow-hidden" style={{
          backgroundColor: '#1e3142'
        }} data-id="element-116">
              {languages.map(lang => <button key={lang.code} onClick={() => {
            setSelectedLanguage(lang.code);
            setIsLanguageMenuOpen(false);
          }} className="w-full flex items-center justify-between px-4 py-3 text-gray-300 hover:text-white transition-colors" onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = '#2d4a63';
          }} onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = 'transparent';
          }} data-id="element-117">
                  <span className="flex items-center gap-2" data-id="element-118">
                    <span data-id="element-119">{lang.flag}</span>
                    <span className="font-medium" data-id="element-120">{lang.name}</span>
                  </span>
                  {selectedLanguage === lang.code && <Check size={16} className="text-blue-400" data-id="element-121" />}
                </button>)}
            </div>}
        </div>
      </div>
    </aside>;
}